import script from "./VehiclesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehiclesList.vue?vue&type=script&setup=true&lang=ts"

import "./VehiclesList.vue?vue&type=style&index=0&id=7415a052&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7415a052"]])

export default __exports__